import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
import Default from '~/pages/templates/default';
import Faq from '~/pages/templates/faq';
import Landing from '~/pages/templates/langingspage';
import page from '~/plugins/mixins/page';
import faq from '~/graphql/queries/faq.gql';
export default {
  apollo: {
    faq: {
      query: faq
    }
  },
  components: [Default],
  mixins: [page],
  auth: false,
  data: function data() {
    return {
      faq: []
    };
  },
  computed: {
    template: function template() {
      switch (this.page.template.__typename) {
        case 'TemplateFaq':
          return Faq;

        case 'TemplateLandingspagina':
          return Landing;

        default:
          return Default;
      }
    }
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var localizedSiblings, routeParams;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              localizedSiblings = JSON.parse(_this.page.locale_siblings);
              routeParams = _defineProperty({}, _this.$i18n.locale, {
                pathMatch: _this.$route.path.slice(1)
              });
              Object.keys(localizedSiblings).forEach(function (locale) {
                routeParams[locale] = {
                  pathMatch: localizedSiblings[locale]
                };
              });
              _context.next = 5;
              return _this.$store.dispatch('i18n/setRouteParams', routeParams);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};